import React from 'react';
import { useSelector } from "react-redux";

// Components
import { ConversationNotifications } from '../modules/conversation-notifications/conversation-notifications';

// Styles
import './chat-status-declined.scss';

// Store entities
import { getGlobalConfigState } from "../../../store/global-config/global-config.selectors";

export const ChatStatusDeclined = () => {

  const { businessTerms } = useSelector(getGlobalConfigState);

  const workerId = localStorage.getItem('worker_id');

  return (<ConversationNotifications
    title={ `${ businessTerms.Consultant } Unavailable` }
    text={ `The ${ businessTerms.Consultant } declined the connection. You may try to contact them later. The payment for the Text Chat will be refunded to you.` }
    navigateAction={ `/expert/${ workerId }/history` }/>);
}
